import { Tag } from '../../domain/nztcs/tag';

export class AssessmentSearchCriteria {
  reportId: number;
  reportName: string;
  showArchived = false;
  reportEditStatusList: string[];
  reportPublishedStatusList: string[];

  umbrellaCategory: string;
  categoryCode: any[] = [];
  assessmentEditStatusList: string[];
  tag: Tag;

  assessmentName: string;
  environment: string;
  taxonomicStatus: string;
  speciesType: string;

  loadPreviousAssessmentDetails: boolean;
  getLatestReport: boolean;

  pageNumber: number;
  pageSize = 20;

  overrideExportWithCurrent = false; // Used to override the export with non-current assessments
}
